<template>
  <SysDialog
    v-model="dialog_ativo_computed"
    titulo="Consolidação dos Pedidos"
    :largura="400"
    ocultar_botao_fechar
  >
    <p class="ma-0 pb-3">
      Deseja unificar os produtos dos pedidos nesse relatório?
    </p>

    <template #actions>
      <v-btn text @click="nao">
        NÂO
      </v-btn>

      <v-btn color="primary" text @click="sim">
        SIM
      </v-btn>
    </template>
  </SysDialog>
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  }
}
</script>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {computed} from "vue";

const props = defineProps({
  modelValue: Boolean,
});

const emit = defineEmits([
  'update:modelValue',
  'sim',
  'nao'
]);

const dialog_ativo_computed = computed({
  get: () => props.modelValue,
  set: valor => emit('update:modelValue', valor)
});

function nao() {
  emit('nao', {});
  dialog_ativo_computed.value = false;
}

function sim() {
  emit('sim', {});
  dialog_ativo_computed.value = false;
}
</script>
